import { render, staticRenderFns } from "./ConfirmForward.vue?vue&type=template&id=738f4955&scoped=true&"
import script from "./ConfirmForward.vue?vue&type=script&lang=js&"
export * from "./ConfirmForward.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmForward.vue?vue&type=style&index=0&id=738f4955&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738f4955",
  null
  
)

export default component.exports